module.exports = __webpack_public_path__ + "static/media/dk.37a18658.svg";